export default __webpack_public_path__ + "images/walmart_logo.png";